<template>
  <div>
    <div class="pt-2 pb-3 px-3">
      <h6 style="font-family: MainFontBold, sans-serif; font-size: 16px; color: #2a2a2a">
        Attributes
      </h6>
      <b-row>
        <b-col
          style="padding-top: 2px"
          @click="origin !== 'edit_product' ? addAttribute() : null"
        >
          <template v-if="origin !== 'edit_product'">
            <img
              src="@/assets/images/icons/add.svg"
              style="cursor: pointer"
              alt="Add Button"
              class="mr-2"
            />
            <label
              class="mb-0 add-attribute-button"
              style="cursor: pointer; position: absolute; top: 7px"
            >
              Add Attribute
            </label>
          </template>
        </b-col>
        <b-col>
          <b-button
            block
            variant="primary"
            class="generate-button shadow-none"
            @click="generate()"
            :disabled="
              enableGenerate() ||
              editingFromLocationsPage ||
              origin == 'edit_product'
            "
          >
            GENERATE
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div role="tablist" style="border-bottom: 1px solid #e7eaf0">
      <b-card
        no-body
        :class="[
          'border-left-0 border-right-0',
          { 'border-bottom-0': index == values.attributes.length - 1 },
        ]"
        v-for="(attribute, index) in values.attributes"
        :key="index"
      >
        <b-card-header
          header-tag="header"
          class="py-1 px-3 pr-0 bg-white"
          role="tab"
        >
          <b-row no-gutters>
            <b-col cols="1">
              <div v-b-toggle="'accordion-' + index">
                <img
                  src="@/assets/images/icons/collapse.svg"
                  alt="Collapsed Icon"
                  class="collapse-icon when-closed"
                />
                <img
                  src="@/assets/images/icons/expand.svg"
                  alt="Expand Icon"
                  class="expand-icon when-opened"
                />
              </div>
            </b-col>
            <b-col>
              <b-form-group
                :id="'attribute-group-' + index"
                :label-for="'attribute-' + index"
                class="mb-0"
                :invalid-feedback="
                  errorMessage('product_attributes.' + index + '.name')
                "
                :state="isValid('product_attributes.' + index + '.name')"
              >
                <b-form-input
                  :id="'attribute-' + index"
                  placeholder="Enter Attribute Name"
                  v-model="attribute.name"
                  :disabled="
                    editingFromLocationsPage || origin == 'edit_product'
                  "
                  class="border-0 shadow-none"
                  maxlength="25"
                  
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="1">
              <img
                src="@/assets/images/actions/delete.svg"
                alt="Delete Button"
                :class="[
                  'delete-button',
                  { 'not-allowed': origin == 'edit_product' },
                ]"
                @click="origin == 'new_product' ? deleteAttribute(index) : null"
                v-if="values.attributes.length > 1"
              />
            </b-col>
          </b-row>
        </b-card-header>
        <b-collapse
          :id="'accordion-' + index"
          visible
          :accordion="'attribute-accordion-' + index"
          role="tabpanel"
        >
          <div class="variation-container">
            <div
              v-for="(variation, sub_index) in values.attributes[index]
                .variations"
              :key="variation.id"
              class="variation py-1 px-3"
            >
              <b-row no-gutters>
                <b-col>
                  <b-form-group
                    :id="'attribute-group-' + index"
                    :label-for="'attribute-' + index"
                    class="mb-0"
                  >
                    <b-form-input
                      :id="'attribute-' + index"
                      placeholder="Enter Variation Name"
                      v-model="variation.name"
                      :disabled="
                        editingFromLocationsPage || origin == 'edit_product'
                      "
                      maxlength="25"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="1"
                  v-if="
                    values.attributes[index].variations.length > 1 &&
                    variation.action == 'create'
                  "
                  :id="
                    origin == 'edit_product'
                      ? 'epopover-' + index + '-' + sub_index
                      : 'popover-' + index + '-' + sub_index
                  "
                  style="cursor: pointer"
                  @click="openAllPopovers(origin, index, sub_index)"
                >
                  <img
                    src="@/assets/images/actions/options.svg"
                    alt="Options Button"
                    class="options-button"
                  />
                  <b-popover
                    :target="
                      origin == 'edit_product'
                        ? 'epopover-' + index + '-' + sub_index
                        : 'popover-' + index + '-' + sub_index
                    "
                    triggers="click"
                    class="inventory-popover"
                  >
                    <span
                      style="cursor: pointer"
                      @click="
                        deleteVariation({
                          attribute: index,
                          variation: sub_index,
                        })
                      "
                    >
                      Delete
                    </span>
                  </b-popover>
                </b-col>
              </b-row>
            </div>
            <div class="variation px-3 add-variation">
              <b-row no-gutters>
                <b-col style="cursor: pointer" @click="addVariation(index)">
                  <img
                    src="@/assets/images/icons/add.svg"
                    alt="Add Button"
                    class="add-variation-button mr-2"
                  />
                  <label
                    class="mb-0"
                    style="position: absolute; top: 2px; cursor: pointer"
                  >
                    Add Variation
                  </label>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Variables",
    props: ["values", "origin"],
    computed: {
        ...mapState("estoreInventories", ["errors"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"])
    },
    methods: {
        addAttribute: function() {
            this.$emit("addAttribute", {
                action: "create",
                name: "",
                variations: [
                    {
                        action: "create",
                        name: ""
                    }
                ]
            });
        },
        generate: function() {
            this.$emit("generateVariations");
        },
        addVariation: function(index) {
            if (this.origin != "edit_product") {
                this.$emit("addVariation", index);
            }
        },
        enableGenerate: function() {
            if (this.values.attributes.length > 0) {
                return this.values.attributes[0].name !== "" &&
                    this.values.attributes[0].variations[0].name !== ""
                    ? false
                    : true;
            }
            return true;
        },
        deleteVariation: function(param) {
            this.$emit("deleteVariation", param);
        },
        deleteAttribute: function(index) {
            this.$emit("deleteAttribute", index);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },
        openAllPopovers(origin, index, sub_index) {
            this.$root.$emit("bv::hide::popover");
            let popoverId = "";
            if (origin == "edit_product") {
                popoverId = "epopover-" + index + "-" + sub_index;
            } else {
                popoverId = "popover-" + index + "-" + sub_index;
            }
            this.$root.$emit("bv::show::popover", popoverId);
        }
    }
};
</script>
